import React from 'react';
import OpenApiElements from '@/components/OpenApiElements';
import './index.less';

export default () => (
  <OpenApiElements
    apiDescriptionUrl={process.env.REACT_APP_MIDDLE_PLATFORM_SUPPLIER_APP_HOST}
  />
);
